import { Notification, Message } from 'element-ui'
import * as codeGeneretor from 'voucher-code-generator'
import * as dayjs from 'dayjs'
export default {
  formatDate (date, format = 'YYYY/MM/DD') {
    return dayjs(date).format(format)
  },
  formatPrice (value) {
    return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  generateDiscountCode () {
    return codeGeneretor.generate({
      prefix: 'TOKTOK-',
      postfix: '-' + dayjs().format('YYYY'),
      length: 5,
      count: 1
    })[0].toUpperCase()
  }
}
export function showNotification (type, title, msg) {
  if (type !== 'error') {
    Notification({
      title: title,
      message: msg,
      type: type
    })
  } else {
    Notification.error({
      title: title,
      message: msg
    })
  }
}
export function showMessage (type, msg) {
  if (type === '') {
    Message({
      showClose: true,
      center: true,
      message: msg,
      type: type
    })
  } else if (type === 'error') {
    Message.error({
      showClose: true,
      center: true,
      message: msg
    })
  } else {
    Message({
      showClose: true,
      center: true,
      message: msg,
      type: type
    })
  }
}
